(() => {
  const callback = () => {
    const PUBLIC_API_KEY = 'Smb5Zd';

    const subscribeToVariantStock = async ({ email, variantId }) => {
      if (!email || !variantId) return;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      };

      try {
        const request = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${PUBLIC_API_KEY}`,
          requestOptions,
        );

        showState({ state: request.ok ? 'success' : 'error' });
      } catch (error) {
        showState({ state: 'error' });
        console.error(error);
      }
    };

    const subscribeToList = async ({ email, listId }) => {
      if (!email || !listId) return;

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-07-15',
        },
        body: JSON.stringify(payload),
      };

      try {
        await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`, requestOptions);
      } catch (error) {
        console.error(error);
      }
    };

    const showState = ({ state }) => {
      const states = container.querySelectorAll(selectors.content);
      states.forEach((element) => {
        element.classList.toggle('hidden', element.dataset.state !== state);
      });
    };

    const selectors = {
      container: '.back-in-stock',
      variantTitle: '.back-in-stock__popup-variant-title',
      content: '.back-in-stock__popup-content',
      form: '.back-in-stock__popup-form',
      formVariantIdInput: 'input#back-in-stock-variant',
      formSubmitButton: '.back-in-stock__popup-form-submit-button',
    };

    const container = document.querySelector(selectors.container);
    if (!container) return;

    const variantTitle = container.querySelector(selectors.variantTitle);
    const form = container.querySelector(selectors.form);
    const formVariantIdInput = container.querySelector(selectors.formVariantIdInput);
    const formSubmitButton = container.querySelector(selectors.formSubmitButton);

    const hasMissingElements = [form, variantTitle, formVariantIdInput].some((element) => !element);
    if (hasMissingElements) return;

    const { marketingListId } = window.themeComponents.snippets['back-in-stock-ds'] ?? {};

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      formSubmitButton.classList.add('btn--loading');

      const formData = new FormData(form);
      const {
        email,
        'variant-id': variantId,
        'accept-marketing': acceptMarketing,
      } = Object.fromEntries(formData.entries());

      if (!email || !variantId) {
        showState({ state: 'error' });
        return;
      }

      await subscribeToVariantStock({ email, variantId });

      if (!!acceptMarketing) {
        await subscribeToList({ email, listId: marketingListId });
      }

      formSubmitButton.classList.remove('btn--loading');
    });

    document.addEventListener('variant:change', (event) => {
      const { variant } = event?.detail ?? {};

      if (variant.title) variantTitle.innerHTML = variant.title;
      if (variant.id) formVariantIdInput.value = variant.id;
      container.classList.toggle('hidden', variant?.available);
    });
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
